/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Obligations_S43_Item_3Inputs */

const es_tyc_obligations_s43_item_3 = /** @type {(inputs: Tyc_Obligations_S43_Item_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los retrasos o inconsistencias en Fuentes Conectadas pueden afectar el Servicio sin responsabilidad para Nexata.`)
};

const en_tyc_obligations_s43_item_3 = /** @type {(inputs: Tyc_Obligations_S43_Item_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delays or inconsistencies in Connected Sources may affect the Service without liability to Nexata.`)
};

/**
* | output |
* | --- |
* | "Delays or inconsistencies in Connected Sources may affect the Service without liability to Nexata." |
*
* @param {Tyc_Obligations_S43_Item_3Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_obligations_s43_item_3 = /** @type {((inputs?: Tyc_Obligations_S43_Item_3Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Obligations_S43_Item_3Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_obligations_s43_item_3(inputs)
	return en_tyc_obligations_s43_item_3(inputs)
});
export { tyc_obligations_s43_item_3 as "tyc.obligations.s43_item_3" }